module.exports = __webpack_public_path__ + "assets/img/6.95622b8b.jpg";